import { render, staticRenderFns } from "./ImportResult.vue?vue&type=template&id=3bf04f1d"
import script from "./ImportResult.vue?vue&type=script&lang=js"
export * from "./ImportResult.vue?vue&type=script&lang=js"
import style0 from "./ImportResult.vue?vue&type=style&index=0&id=3bf04f1d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports